import { render } from "./Switch.vue?vue&type=template&id=451c3480&scoped=true&bindings={}"
import script from "./Switch.vue?vue&type=script&lang=ts"
export * from "./Switch.vue?vue&type=script&lang=ts"

import "./Switch.vue?vue&type=style&index=0&id=451c3480&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-451c3480"

export default script